module.exports = __webpack_public_path__ + "static/media/icNoPreviewText.731286f5.svg";